import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Global Actions
// @ts-ignore
import { requestEventCancelLabels } from 'services/containerGroups/actions';

// Global Selectors
import { makeSelectHarvestEventId } from 'services/harvestEvents/selectors';

interface OwnProps {
    harvestEventUuid: string;
    label: string;
}

interface ConnectedProps {
    eventId?: number;
    requestEventCancelLabels?: Function;
}

type Props = OwnProps & ConnectedProps;

export class ContainerGroupCancelButton extends React.PureComponent<Props> {
    handleClick(): void {
        const { eventId, requestEventCancelLabels: cancel } = this.props;

        cancel && cancel(eventId);
    }

    render(): React.ReactElement | null {
        const { label } = this.props;

        return (
            <Button
                negative
                fluid
                namespace="EVENT_LABELS_CANCEL"
                onClick={(): void => {
                    this.handleClick();
                }}
            >
                {label}
            </Button>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, OwnProps, any>({
    eventId: makeSelectHarvestEventId()
});

export default connect(mapStateToProps, { requestEventCancelLabels })(
    ContainerGroupCancelButton
);
